import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { FmButton } from './FmButton';

export interface ReportNavBackActionDescriptor {
  label: string;
  onActivate: () => void;
}

interface ReportNavBackActionProps {
  action?: ReportNavBackActionDescriptor;
  testId: string;
  /** The rail's class for the label, so a rail can decide when only the arrow shows. */
  labelClassName?: string;
}

/** Optional origin-aware return action rendered inside the report nav rail. */
export const ReportNavBackAction: React.FC<ReportNavBackActionProps> = ({
  action,
  testId,
  labelClassName,
}) =>
  action ? (
    <FmButton
      variant="text"
      size="md"
      data-testid={testId}
      leadingIcon={<ArrowLeftOutlined />}
      onClick={action.onActivate}
    >
      {labelClassName ? <span className={labelClassName}>{action.label}</span> : action.label}
    </FmButton>
  ) : null;

ReportNavBackAction.displayName = 'ReportNavBackAction';
